// extracted by mini-css-extract-plugin
export default {"createNoteHolder":"Vendor_createNoteHolder__7r3iJ","btnHolder":"Vendor_btnHolder__ZkNi4"};